<!-- eslint-disable max-len -->
<template>
  <div>
    <h2>{{ (link && link.name) ? link.name : 'Content Purchase' }}</h2>
    <div v-if="expirationLabel" style="margin-bottom: 15px;">
      <b-alert show variant="info">
        <strong>Content Expiration:</strong> {{ expirationLabel }}
      </b-alert>
    </div>
    <template v-if="hasItems">
      <p>
        Select the content you would like to purchase.
        <span class="muted-note">({{selectedCount}} of {{items.length}} selected)</span>
      </p>
      <table class="table">
        <thead>
          <tr>
            <th style="width: 40px;"> </th>
            <th>Content</th>
            <th style="text-align: right;">Price</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" :key="idOf(item && item.gameSet)">
            <td>
              <input
                type="checkbox"
                class="form-check-input"
                style="margin: 0;"
                :checked="isSelected(item)"
                @change="onToggle(idOf(item && item.gameSet))"
              >
            </td>
            <td>
              <div class="item-name">{{displayName(item)}}</div>
              <ul v-if="gamesOf(item).length" class="muted-note">
                <li
                  v-for="game in gamesOf(item)"
                  :key="`${idOf(game)}`"
                >
                  {{gameDisplayName(game)}}
                </li>
              </ul>
            </td>
            <td style="text-align: right;">{{priceString(item)}}</td>
          </tr>
        </tbody>
      </table>
    </template>
    <template v-else>
      <p>No content is available for this registration link. Please contact support.</p>
    </template>
  </div>
</template>

<script>
/** Accepts a populated doc or a raw id and returns the id. */
export function idOf(x) {
  if (!x) return null;
  if (x._id) return x._id;
  if (x.id) return x.id;
  if (typeof x === 'string') return x;
  return x;
}

export default {
  props: {
    items: { type: Array, required: false, default: () => [] },
    selectedItemIds: { type: Array, required: true },
    onToggle: { type: Function, required: true },
    link: { type: Object, required: true },
    expirationLabel: { type: String, required: false, default: null }
  },
  computed: {
    hasItems() {
      return Array.isArray(this.items) && this.items.length > 0;
    },
    selectedCount() {
      return this.selectedItemIds.length;
    }
  },
  methods: {
    idOf,
    isSelected(item) {
      return this.selectedItemIds.includes(idOf(item && item.gameSet));
    },
    gameSetOf(item) {
      return item && item.gameSet;
    },
    displayName(item) {
      const gs = this.gameSetOf(item);
      if (gs && typeof gs === 'object') {
        const firstGame = (Array.isArray(gs.games) && gs.games.length > 0) ? gs.games[0]._id : null;
        return gs.name || gs.title
          || (firstGame && (firstGame.name || firstGame.title))
          || gs._id || gs.id || '(item)';
      }
      return gs || '(item)';
    },
    gamesOf(item) {
      const gs = this.gameSetOf(item);
      if (!gs || typeof gs !== 'object') return [];
      if (gs.description) return gs.description;
      return (Array.isArray(gs.games) && gs.games.length > 0) ? gs.games.map(({ _id }) => _id) : [];
    },
    removeTags(text) {
      return text
        ? (text
          .replace(/<(br|center|strong|div|span)(>|\/>| [^>]*>)/g, '') // start/standalone tags
          .replace(/<\/(br|center|strong|div|span)>/g, '')) // end tags
        : '';
    },
    gameDisplayName(game) {
      if (!game) return 'Gamulation';
      return this.removeTags(game.thumbnailTitle || game.title) || 'Gamulation';
    },
    priceString(item) {
      const price = Number(item && item.price);
      return isNaN(price) ? '' : `$${price.toFixed(2)}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.item-name
{
  font-weight: bold;
}

.muted-note
{
  color: gray;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/braintree/CatalogInfoPage.vue